import React from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import { RepeatingPattern } from '../../../types';
import styles from '../../prediction-header-bar/prediction-header-bar.scss';

interface OutputFrequencyProps {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value: RepeatingPattern | null;
}

export const OutputFrequency = ({ disabled, onChange, value }: OutputFrequencyProps) => {
  const intl = useIntl();

  return (
    <div className={styles.formInput}>
      <Select
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value || ''}
        label={intl.formatMessage({ id: 'predict.output_frequency', defaultMessage: 'Output frequency' })}
        size="large"
      >
        <Option
          text={intl.formatMessage({ id: 'common.output_frequency_daily', defaultMessage: 'Daily' })}
          value={RepeatingPattern.daily}
        />
        <Option
          text={intl.formatMessage({ id: 'common.output_frequency_monthly', defaultMessage: 'Monthly' })}
          value={RepeatingPattern.monthly}
        />
        <Option
          text={intl.formatMessage({ id: 'common.output_frequency_annually', defaultMessage: 'Annually' })}
          value={RepeatingPattern.annually}
        />
      </Select>
    </div>
  );
};
